import RequestResetPassword from "pages/AuthPage/components/RequestResetPassword/RequestResetPassword";

export default RequestResetPassword;
